import { VStack, Box, Button } from '@cad-arc';
import { EventSearchOptions } from '@mark43/cad-api';
import { useFieldArray, UseFormReturn } from 'react-hook-form';
import { propertyFormDefaultValues } from './configuration';
import { EventSearchFormPropertyFields } from './event-search-form-property-fields';
import { FormSection } from '../search-windows/form-section';
import { EventSearchFormType } from './types';

const MAX_PROPERTY_COUNT = 3;

export function EventSearchFormInvolvedItemInformationSection({
    form,
    options,
    isFirstResponder,
}: {
    form: UseFormReturn<EventSearchFormType>;
    options: EventSearchOptions;
    isFirstResponder?: boolean;
}) {
    const { fields, append, remove } = useFieldArray({
        control: form.control,
        name: 'involvedItems',
    });
    return (
        <FormSection
            title="Property Information"
            testId="event-search-property-information-section"
        >
            <VStack align="left" gap="4px">
                {fields.map((field, index) => {
                    return (
                        <EventSearchFormPropertyFields
                            key={field.id}
                            form={form}
                            options={options}
                            index={index}
                            isRemovable={fields.length > 1}
                            isFirstResponder={isFirstResponder}
                            onRemove={() => remove(index)}
                        />
                    );
                })}
                <Box w="122px">
                    <Button
                        variant="ghost"
                        leadingVisual="Add"
                        onClick={() => append(propertyFormDefaultValues)}
                        isDisabled={fields.length >= MAX_PROPERTY_COUNT}
                    >
                        Add Property
                    </Button>
                </Box>
            </VStack>
        </FormSection>
    );
}
